import React, { useState } from 'react';
import { List, Avatar, Space, Button, notification } from 'antd';
import { BankOutlined, LikeOutlined, MessageOutlined, UserAddOutlined, UserOutlined } from '@ant-design/icons';
import { IconTextProps, DataItem, RecordStatus, RequestStatus, Contact, PageSetting } from '../..';
import { saveRequest, sendNotification } from '../../../controllers/connection';
import { getSended } from '../../../controllers/store/actions/connection/connection-sended-actions';
import { RequestConnection } from '../../../models/RequestConnection';
import ConnectionRequest from '../Forms/Modal/ConnectionRequest/Connection-Request';
import { useSelector } from 'react-redux';
import store from '../../../controllers/store';

const IconText: React.FC<IconTextProps> = ({ icon: Icon, text }) => (
    <Space>
        {React.createElement(Icon)}
        {text}
    </Space>
);

interface Props {
    totalPages?: number;
    onPaginationChanged: (page: number) => void;
    onConnect: (contact: any) => void;
    data: DataItem[];
}
const RecomendationList: React.FC<Props> = ({ data, onConnect, onPaginationChanged, totalPages }) => {
    console.log("data", data);
    return (
        <List
            itemLayout="vertical"
            size="large"
            pagination={{
                simple: true,
                total: totalPages,
                onChange: (page) => {
                    onPaginationChanged(page)
                },
                pageSize: PageSetting.limit,
            }}
            dataSource={data}
            renderItem={(item: DataItem) => (
                <>
                    <List.Item
                        key={item.title}
                        actions={[
                            <Button
                                type='link'
                                style={{color : "#F37221", fontWeight : "bolder"}}
                                icon={<UserAddOutlined />}
                                onClick={() => onConnect(item)}
                                size={'small'}>Conectar</Button>,
                        ]}
                    >
                        <List.Item.Meta
                            avatar={<Avatar icon={item.description === "Empresas" ? (<UserOutlined />) : (<BankOutlined />)} />}
                            title={<a href={item.href}>{item.title}</a>}
                            description={item.description}
                        />
                        {item.content}
                    </List.Item>
                </>
            )}
        />
    );
}


export default RecomendationList;